import React from 'react'

export default function TypeFile({ questiondata, setQuestionData }: any): JSX.Element {
    return (
        <div>
            <h5>Los alumnos responderán la pregunta adjuntando un archivo</h5>
        </div>
    )
}
